const steps = [
  {
    step: "01",
    title: "Data Collection",
    description: "Market data is gathered from multiple verified sources, ensuring comprehensive product coverage across categories.",
    result: "Product database created",
  },
  {
    step: "02",
    title: "Structuring",
    description: "Raw data is organized into clear spreadsheet format with standardized fields for easy navigation and comparison.",
    result: "Spreadsheet format built",
  },
  {
    step: "03",
    title: "Analysis",
    description: "Metrics like demand, competition, and profit margin are calculated and highlighted for quick decision-making.",
    result: "Trends identified",
  },
  {
    step: "04",
    title: "Selection",
    description: "Users browse structured data, compare products, and select winning items with confidence backed by real numbers.",
    result: "Winning products chosen",
  },
];

export default function HowItWorksSection() {
  return (
    <section id="how-it-works" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          {/* Left */}
          <div className="lg:w-[40%]">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 leading-tight mb-4">
              How OOPBuy Spreadsheet System Works
            </h2>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-md">
              Our structured approach transforms raw market intelligence into actionable product data that helps sellers make faster, smarter sourcing decisions.
            </p>
          </div>

          {/* Right - Steps */}
          <div className="lg:flex-1">
            <div className="overflow-x-auto">
              <table className="w-full text-sm border-collapse">
                <thead>
                  <tr className="border-b border-background-300">
                    <th className="text-left py-3 pr-4 text-xs font-semibold text-foreground-500 uppercase tracking-wider w-16">Step</th>
                    <th className="text-left py-3 px-4 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Action</th>
                    <th className="text-left py-3 pl-4 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Result</th>
                  </tr>
                </thead>
                <tbody>
                  {steps.map((s, idx) => (
                    <tr key={idx} className="border-b border-background-200/70 last:border-0">
                      <td className="py-4 pr-4">
                        <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-accent-100 text-accent-600 text-xs font-bold">
                          {s.step}
                        </span>
                      </td>
                      <td className="py-4 px-4">
                        <p className="font-medium text-foreground-800 mb-0.5">{s.title}</p>
                        <p className="text-xs text-foreground-500 leading-relaxed">{s.description}</p>
                      </td>
                      <td className="py-4 pl-4">
                        <span className="inline-flex items-center gap-1 text-xs text-accent-600 font-medium whitespace-nowrap">
                          <i className="ri-check-line"></i> {s.result}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}